module.exports = __webpack_public_path__ + "static/media/table-cream.4f78c0d9.png";